<script setup>
import {computed} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useComponentsStore} from '@/stores/components'
import {useModalsStore} from '@/stores/modals'
import api from '@/services/api'

const route = useRoute()
const router = useRouter()

// Pinia Stores
const componentsStore = useComponentsStore()
const modalsStore = useModalsStore()

// --- Computed ---

const tableName = computed(() => route.params.component)

const component = computed(() => {
    return componentsStore.items.find(o => o.tableName === tableName.value)
})

const isForm = computed(() => component.value?.navigationGroup === 'Forms')

const label = computed(() => isForm.value ? 'form' : 'content type')

// --- Methods ---

const duplicateForm = () => {
    modalsStore.show({
        componentName: 'ConfirmModal',
        obj: {
            modalTitle: 'Are you sure?',
            onConfirm: async () => {
                try {
                    // 1. Request the copy via API
                    const response = await api.post(`api/component/modulecomponents?copyId=${component.value.id}`)

                    const newTableName = response.data.tableName

                    // 2. Re-initialize the global components list via Pinia
                    await componentsStore.init()

                    // 3. Navigate to the settings of the newly created component
                    await router.push({
                        name: 'componentSettings',
                        params: {component: newTableName}
                    })
                } catch (error) {
                    console.error("Failed to duplicate component:", error)
                }
            }
        }
    })
}
</script>

<template>
    <div class="root">
        <div>
            <h5 class="list-group-item-heading">Duplicate this {{ label }}</h5>

            <p class="mb-0">
                Duplicates the {{ label }}'s settings and fields.
            </p>
        </div>

        <button class="btn btn-success ms-2" type="button" @click="duplicateForm">
            Duplicate this {{ label }}
        </button>
    </div>
</template>

<style scoped>
.root {
    display: flex;
    align-items: center;
    font-size: 14px;
}

.root > :first-child {
    flex: auto;
}
</style>